import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import axiosInstance from "axiosConfig";
import { queryClient } from "App";
import { SESSION_QUERY_KEY } from "./CheckSessionHook";

interface GetSuccessorsHookType {
  enabled?: boolean;
}

export function useGetSuccessors({
  enabled,
}: GetSuccessorsHookType) {
  const query = useQuery({
    queryKey: ["successors-list"],
    queryFn: async () => {
      return axiosInstance.get(`/successors`).then((res) => res);
    },
    placeholderData: keepPreviousData,
    select: ({data}) => data, 
    retry: false,
    enabled,
    staleTime: 1000 * 15,
  });

  useEffect(() => {
    if (query.error) {
      queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY });
    }
  }, [query.error]);

  return query;
}
